import HomepageMenusClient from './api';

export default context => {
  const homepageMenusClient = HomepageMenusClient(context);

  return {
    namespaced: true,
    state: {
      menus: [],
      categories: [],
    },
    mutations: {
      updateMenus(state, menus) {
        state.menus = menus;
      },
      updateCategories(state, categories) {
        state.categories = categories;
      },
    },
    actions: {
      async getMenus({ commit }) {
        const res = await homepageMenusClient.getMenus({
          headers: {
            'X-Revamp': true,
          },
          params: {
            platform: 'desktop_web',
          },
        });

        commit('updateMenus', res.data);

        return res;
      },
      async getCategories({ commit }) {
        const res = await homepageMenusClient.getCategories({
          headers: {
            'X-Revamp': true,
          },
          params: {
            platform: 'desktop_web',
          },
        });

        commit('updateCategories', res.data);

        return res;
      },
    },
  };
};
